export const ACTIVITY_THREAD_QUICK_FILTER_VALUES = [
  'all',
  'favorites',
  'new_leads',
  'unread',
  'attention',
  'my_overdue',
  'overdue',
] as const;

export type ActivityThreadQuickFilter = (typeof ACTIVITY_THREAD_QUICK_FILTER_VALUES)[number];

export type ActivityThreadQuickFilterCounters = {
  favorites: number;
  favorites_unread_threads: number;
  favorites_overdue_threads: number;
  new_leads: number;
  unread: number;
  attention: number;
  my_overdue: number;
  overdue: number;
};

export const DEFAULT_ACTIVITY_THREAD_QUICK_FILTER_COUNTERS: ActivityThreadQuickFilterCounters = {
  favorites: 0,
  favorites_unread_threads: 0,
  favorites_overdue_threads: 0,
  new_leads: 0,
  unread: 0,
  attention: 0,
  my_overdue: 0,
  overdue: 0,
};

export function normalizeActivityThreadQuickFilter(value: unknown): ActivityThreadQuickFilter {
  if (typeof value !== 'string') return 'all';
  return ACTIVITY_THREAD_QUICK_FILTER_VALUES.includes(value as ActivityThreadQuickFilter)
    ? (value as ActivityThreadQuickFilter)
    : 'all';
}
